import React, { useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import { CTAButton } from '../../components/PrimaryCTAButton/CTAButton';
import { NavItems } from '../../components/NavItems/NavItems';
import { InfoContext } from '../../context';
import { ILogo } from '../../types';
import { rootHeaderNavigation } from '../../roots';
import { isColdfusion } from '../../legacy/legacy';
import { isModule } from '../../helpers/windowLocation';
import { resizeNavBar } from '../../legacy/navbarhelper';

/*
 * bynder-platform/bynder/views/navigation/header.cfm
 */
function NavContainer() {
	const [isLoadingLogo, setIsLoadingLogo] = useState(true);
	const { logo, general, homepage } = useContext(InfoContext);

	const isLogoLoaded = !isLoadingLogo || !logo.imageUrl;

	const onNavReady = () => {
		resizeNavBar();
	};

	const onLogoLoaded = () => {
		setIsLoadingLogo(false);
	};

	const showCTAButton =
		(isColdfusion() && !isModule('admin') && !isModule('styleguide') && !isModule('group')) ||
		(homepage.isConfigured && isModule('guidelines'));

	return (
		<>
			<Logo logo={logo} accountName={general.accountName} onLoaded={onLogoLoaded} />

			{isLogoLoaded && <NavItems onReady={onNavReady} />}
			{isLogoLoaded && showCTAButton && <CTAButton />}
		</>
	);
}

interface LogoProps {
	logo: ILogo;
	accountName: string;
	onLoaded: () => void;
}

function Logo({ logo, accountName, onLoaded }: LogoProps) {
	const showImage = !!logo.imageUrl;

	return (
		<a href={logo.linkUrl || '/'} title={accountName} className="account-logo" tabIndex={-1}>
			{showImage && (
				<img
					src={logo.imageUrl}
					alt={logo.imageUrl ? accountName : ''}
					onLoad={onLoaded}
					onError={onLoaded}
				/>
			)}
		</a>
	);
}

export function Navigation() {
	const root = document.querySelector(rootHeaderNavigation);

	if (!root) {
		return null;
	}

	(root as HTMLDivElement).style.setProperty('overflow', 'hidden');

	return createPortal(<NavContainer />, root);
}
